import { apiClient } from './client';

// S22: Withdrawal Request interfaces
export interface WithdrawalRequest {
  id: string;
  amount_cents: number;
  amount_dollars: number;
  status: 'pending' | 'approved' | 'rejected' | 'done' | 'canceled';
  requested_at: string;
  resolved_at?: string;
  user_note?: string;
  admin_note?: string;
  withdrawable_cents_at_request: number;
}

export interface WithdrawalListResponse {
  withdrawals: WithdrawalRequest[];
  pagination: {
    page: number;
    per_page: number;
    total_count: number;
    total_pages: number;
  };
  current_withdrawable_cents: number;
}

export interface CreateWithdrawalParams {
  amount_cents: number;
  user_note?: string;
}

export interface CreateWithdrawalResponse {
  success: boolean;
  withdrawal?: WithdrawalRequest;
  message?: string;
  errors?: string[];
}

export interface CancelWithdrawalResponse {
  success: boolean;
  withdrawal?: WithdrawalRequest;
  message?: string;
  errors?: string[];
}

// S22: Withdrawal Request API endpoints
const withdrawalEndpoints = {
  /**
   * List user's withdrawal requests
   */
  list: async (params?: { page?: number; per?: number }): Promise<WithdrawalListResponse> => {
    const response = await apiClient.get('/api/me/withdrawals', { params });
    return response;
  },

  /**
   * Create a new withdrawal request
   */
  create: async (params: CreateWithdrawalParams): Promise<CreateWithdrawalResponse> => {
    const response = await apiClient.post('/api/me/withdrawals', params);
    return response;
  },

  /**
   * Cancel a pending withdrawal request
   */
  cancel: async (id: string): Promise<CancelWithdrawalResponse> => {
    const response = await apiClient.post(`/api/me/withdrawals/${id}/cancel`);
    return response;
  },
};

export default withdrawalEndpoints;
